import "./RevenueTable.scss";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Legend } from "recharts";
import styled from "styled-components";

export const SubHeader = styled.div`
  width: 490px;
  display: flex;
  justify-content: center;
  padding-left: 25px;
  font-family: Open Sans;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #737b7d;
`;

const currentYear = new Date().getFullYear();

export interface RevenueData {
  monthName: string;
  [propName: string]: number | string;
}

export const yearSuffix = " Actual";

export const RevenueTable: React.FC<{ data: Array<RevenueData> }> = ({
  data,
}) => {
  return (
    <>
      {!data.length && <SubHeader>No Revenue Target Data</SubHeader>}
      <BarChart
        width={499}
        height={315}
        data={data}
        barSize={5}
        margin={{
          top: 10,
        }}
      >
        <CartesianGrid strokeDasharray="0" vertical={false} stroke="#E8E8E8" />
        {!!data.length && (
          <XAxis
            dataKey="monthName"
            axisLine={false}
            tickLine={false}
            tick={{
              fontFamily: "Open Sans",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 600,
              letterSpacing: "0.2px",
              color: "#737B7D",
            }}
          />
        )}
        <YAxis
          axisLine={false}
          tickLine={false}
          tickCount={6}
          tick={{
            fontFamily: "Open Sans",
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 600,
            letterSpacing: "0.2px",
            color: "#737B7D",
          }}
          tickFormatter={value =>
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }).format(value)
          }
        />
        <Legend align="center" iconType="square" />
        <Bar
          dataKey={currentYear - 1 + yearSuffix}
          fill="#A5D8FF"
          radius={[10, 10, 0, 0]}
        />
        <Bar
          dataKey={currentYear + yearSuffix}
          fill="#098EDF"
          radius={[10, 10, 0, 0]}
        />
      </BarChart>
    </>
  );
};
